import { render, staticRenderFns } from "./WrongTownship.vue?vue&type=template&id=4e97b834&scoped=true"
import script from "./WrongTownship.vue?vue&type=script&lang=js"
export * from "./WrongTownship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e97b834",
  null
  
)

export default component.exports